<template>
    <ion-item class="message">
        <ion-avatar v-show="!$root.isMobileOrSmall"
                    slot="start">
            <img
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                alt="">
        </ion-avatar>

        <ion-label>
            <ion-item @click="openMessage(message.id)"
                      lines="none"
                      :button="!$root.isMobileOrSmall">
                <ion-label>
                    <h2>
                        {{ message.sender.email }}
                    </h2>

                    <h3>{{ message.subject }}</h3>
                </ion-label>

                <ion-badge color="primary"
                           slot="end">
                    {{ message.sent_at_short }}
                </ion-badge>
            </ion-item>

            <ion-item v-show="!$root.isMobileOrSmall"
                      v-if="message.attachments && message.attachments.length"
                      class="ion-wrap ion-text-wrap"
                      lines="none"
                      no-margin>
                <incoming-mail-attachment v-for="(attachment, i) in message.attachments"
                                          v-bind:key="`${i}-${attachment.id}`"
                                          :attachment="attachment"/>
            </ion-item>
        </ion-label>
    </ion-item>
</template>

<script>
    import Attachment from "../../Attachment";
    import IncomingMailAttachment from "@/components/IncomingMailAttachment";

    export default {
        components: {IncomingMailAttachment, Attachment},
        name: "ListIncomingMailMessage",
        props: {
            message: {type: Object},
        },
        methods: {
            openMessage(id) {
                this.$router.push({name: 'incoming-mail-message', params: {id}});
            },
        },
    }
</script>
